(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media--variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gallery-media-arrow')) {
    customElements.define('gallery-media-arrow', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.gallery = this.closest('product-thumbs-element');
        this.step = this.getAttribute('direction') === 'previous' ? -1 : 1;
        this.update = () => {
          const thumbs = [...this.gallery.querySelectorAll('.product-media--thumb')];
          const index = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-current') === 'true'));
          this.button.disabled = !thumbs.length || index + this.step < 0 || index + this.step >= thumbs.length;
        };
        this.navigate = event => {
          event.stopPropagation();
          const thumbs = [...this.gallery.querySelectorAll('.product-media--thumb')];
          const index = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-current') === 'true'));
          const target = thumbs[index + this.step];
          if (target) target.click();
        };
        this.button.addEventListener('click', this.navigate);
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.gallery, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.navigate);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
